import React, { Component } from 'react'

import { graphql } from '@apollo/client/react/hoc'
import './TransactionListNew.css'
import { Alert, Button, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Progress } from 'reactstrap'
import Select from "react-select"
import moment from "moment"
import DocumentModalNew from "../../Material/DocumentModal/DocumentModalNew"
import { AllChargeTypes, AllGroupTypes } from "./Queries"
import "./DownloadTransactions.css"

import withApolloClient from '../../withApolloClient'

const ALL_FIELDS = [
    { label: 'Date Added', value: 'date_added', alwaysIncluded: true },
    { label: 'Charge Type', value: 'charge_type', alwaysIncluded: true },
    { label: 'Debit', value: 'debit', alwaysIncluded: true },
    { label: 'Credit', value: 'credit', alwaysIncluded: true },
    { label: 'Balance', value: 'balance', alwaysIncluded: true },
    { label: 'Notes', value: 'notes', alwaysIncluded: false },
    { label: 'Event Date', value: 'event_datetime', alwaysIncluded: false },
    { label: 'Car Vin', value: 'car_vin', alwaysIncluded: false },
    { label: 'Due Date', value: 'due_date', alwaysIncluded: false }
]

const ORDER_BY_OPTIONS = [
    { label: 'Id', value: 'id' },
    { label: 'Date Added', value: 'date_added' },
    { label: 'Event Date', value: 'event_datetime' },
    { label: 'Due Date', value: 'due_date' },
]

class DownloadTransactions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            input: {},
            loading: false,
            reportStartDate: new Date().getDay() === 1
                ? moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
                : moment().startOf('month').format('YYYY-MM-DD'),
            reportEndDate: moment(new Date()).format('YYYY-MM-DD'),
            transactionId: null,
            minAmount: null,
            maxAmount: null,
            groupTypeIds: [],
            chargeTypeIds: [],
            excludeGroupTypeIds: [],
            excludeChargeTypeIds: [],
            selectedFields: [],
            orderDirection: 'asc',
            orderByField: 'date_added',
            draggedIndex: null,
            allFields: [...ALL_FIELDS],
        }
    }

    // Drag & drop logic
    handleDragStart = (index) => {
        this.setState({ draggedIndex: index })
    }

    handleDragOver = (index, e) => {
        e.preventDefault()
        const { draggedIndex, allFields } = this.state
        if (index === draggedIndex) return
        const reordered = [...allFields]
        const dragged = reordered[draggedIndex]
        reordered.splice(draggedIndex, 1)
        reordered.splice(index, 0, dragged)
        this.setState({ allFields: reordered, draggedIndex: index })
    }

    handleDrop = () => {
        this.setState({ draggedIndex: null })
    }

    handleFieldCheckboxChange = (field, checked) => {
        const { selectedFields, allFields } = this.state
        if (checked) {
            this.setState({ selectedFields: [...selectedFields, field.value] })
        } else {
            // Remove from selectedFields
            const newSelectedFields = selectedFields.filter(f => f !== field.value)
            // Move unchecked field to the bottom of allFields
            const newAllFields = [...allFields]
            const idx = newAllFields.findIndex(f => f.value === field.value)
            if (idx > -1) {
                const [removed] = newAllFields.splice(idx, 1)
                newAllFields.push(removed)
            }
            this.setState({
                selectedFields: newSelectedFields,
                allFields: newAllFields
            })
        }
    }

    downloadReport = (e) => {
        e.preventDefault()
        this.setState({ loading: true, downloadSuccess: false, })

        const allFields = this.state.allFields
            .filter(f => f.alwaysIncluded || this.state.selectedFields.includes(f.value))
            .map(f => f.value)

        const fieldsParam = allFields.length > 0 ? `&fields=${allFields.join(',')}` : ''
        const orderByParam = this.state.orderByField
            ? `&order_by=${this.state.orderDirection === 'desc'
                ? `-${this.state.orderByField}` : this.state.orderByField}`
            : ''

        const url = "/billing/driver/" + this.props.driverId + "/history/?" +
            "start_date=" + this.state.reportStartDate +
            "&end_date=" + this.state.reportEndDate +
            (this.state.minAmount ? ("&min_amount=" + this.state.minAmount) : "") +
            (this.state.maxAmount ? ("&max_amount=" + this.state.maxAmount) : "") +
            (this.state.groupTypeIds ? this.state.groupTypeIds.map(id => `&group_type_id=${id}`).join("") : "") +
            (this.state.chargeTypeIds ? this.state.chargeTypeIds.map(id => `&charge_type_id=${id}`).join("") : "") +
            (this.state.excludeGroupTypeIds ? this.state.excludeGroupTypeIds.map(id => `&exclude_group_type_id=${id}`).join("") : "") +
            (this.state.excludeChargeTypeIds ? this.state.excludeChargeTypeIds.map(id => `&exclude_charge_type_id=${id}`).join("") : "") +
            fieldsParam + orderByParam

        fetch(url, { method: "GET" })
            .then((response) => response.blob())
            .then((blob) => {
                var reader = new FileReader()
                reader.readAsDataURL(blob)
                this.setState({ loading: false })
                return new Promise(resolve => {
                    reader.onloadend = () => resolve(reader.result)
                })
            })
            .then((base64) => {
                let docObject = {
                    documentUrl: base64,
                    name: "Transaction History"
                }
                this.setState({ downloadSuccess: true, selectedDocument: docObject, openModal: "viewDocument" })
            })
            .catch((err) => {
                console.log(err)
                this.setState({ loading: false })
            })
    }

    componentDidUpdate(prevProps) {
        if (
            this.state.excludeChargeTypeIds.length === 0 &&
            this.props.allChargeTypes &&
            this.props.allChargeTypes.edges &&
            this.props.allChargeTypes.edges.length > 0
        ) {
            this.setState({
                excludeChargeTypeIds: this.props.allChargeTypes.edges
                    .filter(item =>
                        item.node.name === "Bad Debt Write Off" ||
                        item.node.name === "Reverse Bad Debt Write Off"
                    )
                    .map(item => item.node.id)
            })
        }
    }

    render() {
        const { allFields, selectedFields } = this.state

        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.handleClose} className="download-transaction-modal">
                <ModalHeader>Transaction Statement</ModalHeader>
                {this.state.loading && <Progress animated color="info" value={100} />}
                <Form onSubmit={(e) => this.downloadReport(e)}>
                    <ModalBody>
                        {this.state.downloadSuccess && <Alert color="success">Download Successful.</Alert>}
                        {this.state.openModal === "viewDocument" &&
                            <DocumentModalNew
                                document={this.state.selectedDocument}
                                handleClose={() => this.setState({ selectedDocument: null, openModal: "", downloadSuccess: false })}
                                objectType={"driver"}
                                driverId={this.props.driverId}
                                isPicture={false}
                                allowSendDocToDriver={true}
                                currentUser={this.props.currentUser}
                            />
                        }
                        <Row className="mb-2">
                            <Col xs="12">
                                <h5>Driver Transaction Filters</h5>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="">
                                <FormGroup>
                                    <Label for="reportStartDate">Enter start date</Label>
                                    <Input
                                        type="date"
                                        name="reportStartDate"
                                        id="reportStartDate"
                                        invalid={this.state.reportStartDate === ""}
                                        value={this.state.reportStartDate}
                                        valid={this.state.reportStartDate !== ""}
                                        onChange={(e) => this.setState({ reportStartDate: e.target.value })}
                                        placeholder="Start Date"
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs="6">
                                <FormGroup>
                                    <Label for="reportEndDate">Enter end date</Label>
                                    <Input
                                        type="date"
                                        name="reportEndDate"
                                        id="reportEndDate"
                                        invalid={this.state.reportEndDate === ""}
                                        value={this.state.reportEndDate}
                                        valid={this.state.reportEndDate !== ""}
                                        onChange={(e) => this.setState({ reportEndDate: e.target.value })}
                                        placeholder={"End Date"}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs="6">
                                <FormGroup>
                                    <Label for="chargeTypeId"><small><b>Filter by Charge Type</b></small></Label>
                                    <Select
                                        className="bos-custom-select" classNamePrefix="bos-select"
                                        isLoading={!this.props.allChargeTypes || !this.props.allChargeTypes.edges || !this.props.allChargeTypes.edges.length > 0}
                                        options={this.props.allChargeTypes && this.props.allChargeTypes.edges && this.props.allChargeTypes.edges.length > 0 ?
                                            this.props.allChargeTypes.edges.filter(item =>
                                                this.state.excludeChargeTypeIds && this.state.excludeChargeTypeIds.length > 0 ?
                                                    !this.state.excludeChargeTypeIds.includes(item.node.id) : true).map(item => ({ value: item.node.id, label: item.node.name })
                                                    )
                                            : []
                                        }
                                        onChange={(chargeTypes) => this.setState({ chargeTypeIds: chargeTypes.map(item => item.value) })}
                                        placeholder="Select Charge Types"
                                        isClearable
                                        isMulti
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs="6">
                                <FormGroup>
                                    <Label for="chargeTypeId"><small><b>Filter by Sub-Charge Type</b></small></Label>
                                    <Select
                                        className="bos-custom-select" classNamePrefix="bos-select"
                                        isLoading={!this.props.allGroupTypes || !this.props.allGroupTypes.edges || !this.props.allGroupTypes.edges.length > 0}
                                        options={this.props.allGroupTypes && this.props.allGroupTypes.edges && this.props.allGroupTypes.edges.length > 0 ?
                                            this.props.allGroupTypes.edges.filter(item =>
                                                this.state.excludeGroupTypeIds && this.state.excludeGroupTypeIds.length > 0
                                                    ? !this.state.excludeGroupTypeIds.includes(item.node.id) : true).map(item => ({ value: item.node.id, label: item.node.name })
                                                    )
                                            : []
                                        }
                                        onChange={(groupTypes) => this.setState({ groupTypeIds: groupTypes.map(item => item.value) })}
                                        placeholder="Select Sub-Charge Types"
                                        isClearable
                                        isMulti
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs="6">
                                <FormGroup>
                                    <Label for="chargeTypeId"><small><b>Exclude Charge Types</b></small></Label>
                                    <Select
                                        className="bos-custom-select" classNamePrefix="bos-select"
                                        isLoading={!this.props.allChargeTypes || !this.props.allChargeTypes.edges || !this.props.allChargeTypes.edges.length > 0}
                                        options={this.props.allChargeTypes && this.props.allChargeTypes.edges && this.props.allChargeTypes.edges.length > 0 ?
                                            this.props.allChargeTypes.edges.filter(item =>
                                                this.state.chargeTypeIds && this.state.chargeTypeIds.length > 0 ?
                                                    !this.state.chargeTypeIds.includes(item.node.id) : true).map(item => ({ value: item.node.id, label: item.node.name })
                                                    )
                                            : []
                                        }
                                        value={this.state.excludeChargeTypeIds && this.state.excludeChargeTypeIds.map(id => this.props.allChargeTypes.edges.find(item => item.node.id === id)).map(item => ({ value: item.node.id, label: item.node.name }))}
                                        placeholder="Select Charge Types"
                                        isClearable
                                        isMulti
                                        onChange={(chargeTypes) => this.setState({ excludeChargeTypeIds: chargeTypes.map(item => item.value) })}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs="6">
                                <FormGroup>
                                    <Label for="chargeTypeId"><small><b>Exclude Sub-Charge Types</b></small></Label>
                                    <Select
                                        className="bos-custom-select" classNamePrefix="bos-select"
                                        isLoading={!this.props.allGroupTypes || !this.props.allGroupTypes.edges || !this.props.allGroupTypes.edges.length > 0}
                                        options={this.props.allGroupTypes && this.props.allGroupTypes.edges && this.props.allGroupTypes.edges.length > 0 ?
                                            this.props.allGroupTypes.edges.filter(item =>
                                                this.state.groupTypeIds && this.state.groupTypeIds.length > 0
                                                    ? !this.state.groupTypeIds.includes(item.node.id) : true).map(item => ({ value: item.node.id, label: item.node.name })
                                                    )
                                            : []
                                        }
                                        placeholder="Select Sub-Charge Types"
                                        isClearable
                                        isMulti
                                        onChange={(groupTypes) => this.setState({ excludeGroupTypeIds: groupTypes.map(item => item.value) })}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs="6">
                                <FormGroup>
                                    <Label for="minAmount"><small><b>Min Amount ${this.state.minAmount ? this.state.minAmount : 0}</b></small></Label>
                                    <Input type="number" name="minAmount" id="minAmount" onChange={(e) => this.setState({ minAmount: e.target.value })} />
                                </FormGroup>
                            </Col>
                            <Col xs="6">
                                <FormGroup>
                                    <Label for="maxAmount"><small><b>Max Amount ${this.state.maxAmount ? this.state.maxAmount : 0}</b></small></Label>
                                    <Input type="number" name="maxAmount" id="maxAmount" onChange={(e) => this.setState({ maxAmount: e.target.value })} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <hr />
                        <Row className="mb-3">
                            <Col xs="12">
                                <h5>Customize Statement View</h5>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="6">
                                <h6>Choose Data Fields for Your Statement</h6>
                                <div>
                                    {allFields.map((field, index) => (
                                        <div
                                            key={field.value}
                                            draggable={field.alwaysIncluded || selectedFields.includes(field.value)}
                                            onDragStart={() => (field.alwaysIncluded || selectedFields.includes(field.value)) && this.handleDragStart(index)}
                                            onDragOver={(e) => (field.alwaysIncluded || selectedFields.includes(field.value)) && this.handleDragOver(index, e)}
                                            onDrop={this.handleDrop}
                                            style={{
                                                cursor: (field.alwaysIncluded || selectedFields.includes(field.value)) ? "grab" : "default",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <Input
                                                    type="checkbox"
                                                    checked={field.alwaysIncluded || selectedFields.includes(field.value)}
                                                    disabled={field.alwaysIncluded}
                                                    onChange={(e) => this.handleFieldCheckboxChange(field, e.target.checked)}
                                                    style={{ marginLeft: 5 }}
                                                />
                                                <Label style={{ marginLeft: 25, marginTop: 8, marginBottom: 0 }}>{field.label}</Label>
                                            </div>
                                            {(field.alwaysIncluded || selectedFields.includes(field.value)) && (
                                                <div>
                                                    <i className="fa fa-bars" aria-hidden="true"></i>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </Col>
                            <Col xs="6">
                                <h6>Order By</h6>
                                <Select
                                    className="bos-custom-select"
                                    classNamePrefix="bos-select"
                                    options={ORDER_BY_OPTIONS}
                                    value={ORDER_BY_OPTIONS.find(opt => opt.value === this.state.orderByField)}
                                    onChange={selected => this.setState({ orderByField: selected.value })}
                                    placeholder="Select order field"
                                    isClearable={false}
                                    isDisabled
                                    style={{ width: 180 }}
                                />
                                <div style={{ marginTop: 12 }}>
                                    <Label style={{ marginLeft: 18 }}>
                                        <Input
                                            type="radio"
                                            name="orderDirection"
                                            value="asc"
                                            checked={this.state.orderDirection === 'asc'}
                                            onChange={() => this.setState({ orderDirection: 'asc' })}
                                        />
                                        Ascending
                                    </Label>
                                    <Label style={{ marginLeft: 25 }}>
                                        <Input
                                            type="radio"
                                            name="orderDirection"
                                            value="desc"
                                            checked={this.state.orderDirection === 'desc'}
                                            onChange={() => this.setState({ orderDirection: 'desc' })}
                                        />
                                        Descending
                                    </Label>
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="download-transaction-modal-secondary-btn" onClick={this.props.handleClose}>Close</Button>&nbsp;&nbsp;
                        <Button className="download-transaction-modal-primary-btn" type="submit">Generate Statement</Button>
                    </ModalFooter>
                </Form>
            </Modal>
        )
    }
}

export default graphql(AllChargeTypes, {
    props: ({ data: { allChargeTypes } }) => ({
        allChargeTypes
    })
})(graphql(AllGroupTypes, {
    props: ({ data: { allGroupTypes } }) => ({
        allGroupTypes
    })
})(withApolloClient(DownloadTransactions)))




